export default __webpack_public_path__ + "static/media/WAS0130.34I-35523_-20671_0.646ae654.jpg";